import Machine, { iMachineProps } from "./Machine";
import './datacenter.css'

interface iDatacenterProps {
    name: string;
    machines: iMachineProps[];
}
const sortMachines = (a: iMachineProps, b: iMachineProps) => {
    return a.sessionUrl.localeCompare(b.sessionUrl);
}

const Datacenter = ({name, machines}: iDatacenterProps)=> {
    const sorted = machines.sort((a:iMachineProps, b:iMachineProps) =>
        a.sessionUrl.localeCompare(b.sessionUrl, undefined, { numeric: true, sensitivity: 'base' })
    );
    return <div className="datacenter">
        <h2 className="datacenterName">
            {name}
        </h2>
        <div className="datacenterList">
        { sorted.map((machine, index) => <Machine key={index} {...machine} />) }

        </div>
    </div>
}


export default Datacenter;